const initialState ={
  queue_loading:false,
  list_loading:false,
  all_lists:false,
  refresh:0
}

const reducer = (state = initialState, action) => {
  let newState=state;
  switch(action.type){
    case 'SWITCH_WORKSPACE':
      newState=initialState
      break;
    case 'REQUEST_LIST_UPDATE':
    case 'REQUEST_LIST_INDEX':
    case 'REQUEST_LIST_GET':
    case 'REQUEST_LIST_CREATE':
    case 'REQUEST_LIST_UPDATE':
      newState.list_loading=true;
      break;
    case 'REQUEST_LIST_DELETE_SUCCESS':
       window.location.href='/';
       break;
    case 'REQUEST_QUEUE_DELETE_SUCCESS':
       window.location.href='/companies/table/f/eyJxdWV1ZV9pZCI6ImFsbCJ9';
       break;
    case 'REQUEST_UPDATE_WORKSPACE_TOGGLE_SWITCH':
       newState.list_loading=true;
       break;
    case 'REQUEST_UPDATE_WORKSPACE_TOGGLE_SWITCH_SUCCESS':
       newState.list_loading=false;
       break;
    case 'REQUEST_LIST_MERGE_SUCCESS':
       newState.list_loading=false;
       newState.data[action.val.list.id]=action.val.list;
       for(let x of action.val.merged_lists){delete newState.data[x];}
      break;
    case 'REQUEST_LIST_INDEX_SUCCESS':
      newState.list_loading=false;
      newState.all_lists=true;
      if(newState.data==undefined){newState.data={}}
      for(let list of action.val.lists){let x=list; if(newState.data[list.id]!=undefined){x={...newState.data[list.id], ...list}} newState.data[list.id]=list;}
      newState.default=action.val.default_list_id;
      break;
    case 'REQUEST_DELETE_COMPANIES_SUCCESS':
      for(let d_id of action.val){for(let key in newState.data){let list=newState.data[key]; let new_ids=[]; if(list.companies!=undefined && list.companies.includes(d_id)){for(let id of list.companies){if(id!=d_id){new_ids.push(id);}} newState.data[key].companies=new_ids;}}}
      break;
    case 'REQUEST_COMPANY_DELETE_SUCCESS':
      for(let key in newState.data){let list=newState.data[key]; let new_ids=[]; if(list.companies!=undefined && list.companies.includes(action.val.id)){for(let id of list.companies){if(id!=action.val.id){new_ids.push(id);}} newState.data[key].companies=new_ids;}}
      break;
    case 'REQUEST_LIST_GET_SUCCESS':
    case 'REQUEST_LIST_CREATE_SUCCESS':
    case 'REQUEST_LIST_UPDATE_SUCCESS':
      newState.list_loading=false;
      if(newState.data==undefined){newState.data={}}
      newState.data[action.val.id]={...action.val, companies:setCompanyIds(action.val)}
      newState.data[action.val.id].refresh+=1;
      break;
    case 'REQUEST_QUEUE_UPDATE':
    case 'REQUEST_QUEUE_INDEX':
    case 'REQUEST_QUEUE_GET':
    case 'REQUEST_QUEUE_CREATE':
    case 'REQUEST_QUEUE_UPDATE':
      newState.queue_loading=true;
      break;
    case 'REQUEST_TIMELINE_ITEM_CREATE_SUCCESS_QUEUE':
      if(action.val.new_queue!=undefined){
        if(newState.queue_data==undefined){newState.queue_data={}}
        newState.queue_data[action.val.new_queue.id]={...action.val.new_queue, companies:[]}
      }
      break;
    case 'REQUEST_QUEUE_GET_SUCCESS':
    case 'REQUEST_QUEUE_CREATE_SUCCESS':
    case 'REQUEST_QUEUE_UPDATE_SUCCESS':
      newState.queue_loading=false;
      if(newState.queue_data==undefined){newState.queue_data={}}
      newState.queue_data[action.val.id]={...action.val, companies:setCompanyIds(action.val)}
      newState.refresh+=1;
      break;
    case 'REQUEST_QUEUE_DELETE_SUCCESS':
       window.location.href='/';
       break;
    case 'REQUEST_QUEUE_MERGE_SUCCESS':
       newState.queue_loading=false;
       newState.queue_data[action.val.queue.id]=action.val.queue;
       for(let x of action.val.merged_queues){delete newState.queue_data[x];}
      break;
    case 'REQUEST_QUEUE_INDEX_SUCCESS':
      newState.queue_loading=false;
      newState.all_queues=true;
      if(newState.queue_data==undefined){newState.queue_data={}}
      for(let queue of action.val.queues){let x=queue; if(newState.queue_data[queue.id]!=undefined){x={...newState.queue_data[queue.id], ...queue}} newState.queue_data[queue.id]=queue;}
      newState.default=action.val.default_list_id;
      console.log(newState, 'qzy');
      break;
    case 'REQUEST_LIST_MERGE':

    }
  return newState;
}

function setCompanyIds(list){let company_ids=[]; if(list.companies!=undefined){for(let company of list.companies){company_ids.push(company.id);}} return company_ids;}

export default reducer;
